class Sticky {
	constructor() {
		this.$stickyComponents = document.querySelectorAll(
			'.component-sticky__sticky'
		);

		this.stickyComponentAttributes = [];

		this.$stickyComponents.forEach((el, i) => {
			this.stickyComponentAttributes[i] = {};
			this.stickyComponentAttributes[i].el = el;
			const borderBottomWidth = getComputedStyle(
				el.closest('.component-sticky')
			)
				.getPropertyValue('border-bottom-width')
				.match(/\d+/);
			if (borderBottomWidth[0] && parseInt(borderBottomWidth[0])) {
				this.stickyComponentAttributes[i].navHeight =
					el.offsetHeight + parseInt(borderBottomWidth[0]) + 1;
			} else {
				this.stickyComponentAttributes[i].navHeight = el.offsetHeight;
			}
			// TODO: Only do link stuff if link data is specified
			// TODO: Only accept anchor links if it includes a hash
			this.stickyComponentAttributes[i].anchorLinks = el.closest(
				'.component-sticky'
			).dataset.linkClass
				? el.querySelectorAll(
						'.' + el.closest('.component-sticky').dataset.linkClass
				  )
				: [];
			this.stickyComponentAttributes[i].targetPositions = [];
			this.stickyComponentAttributes[i].stickTop = this.getCoords(
				el.closest('.component-sticky')
			).top;
			const stopTargets = el
				.closest('.component-sticky')
				.dataset.stop.split(',')
				.map((element) => {
					return element.trim();
				});
			const stopPositions = [];
			stopTargets.forEach((el2) => {
				document.querySelectorAll(el2).forEach((el3) => {
					stopPositions.push(this.getCoords(el3).top);
				});
			});
			let logicalStop = 0;
			stopPositions.sort(function (a, b) {
				return a - b;
			});
			stopPositions.forEach((el2) => {
				if (
					0 === logicalStop &&
					el2 > this.stickyComponentAttributes[i].stickTop
				) {
					logicalStop = el2;
				}
			});
			this.stickyComponentAttributes[i].stickBottom = logicalStop;
			this.stickyComponentAttributes[i].linkActiveClass =
				el.closest('.component-sticky').dataset.linkActiveClass;

			el.closest('.component-sticky').style.height =
				this.stickyComponentAttributes[i].navHeight + 'px';
		});
	}
	getTargetPositions() {
		// loop nav to find targets and get their positions

		this.stickyComponentAttributes.forEach((item, i) => {
			this.stickyComponentAttributes[i].navHeight = item.el.offsetHeight;
			const borderBottomWidth = getComputedStyle(
				item.el.closest('.component-sticky')
			)
				.getPropertyValue('border-bottom-width')
				.match(/\d+/);
			if (borderBottomWidth[0] && parseInt(borderBottomWidth[0])) {
				this.stickyComponentAttributes[i].navHeight =
					item.el.offsetHeight + parseInt(borderBottomWidth[0]) + 1;
			} else {
				this.stickyComponentAttributes[i].navHeight =
					item.el.offsetHeight;
			}
			this.stickyComponentAttributes[i].stickTop = this.getCoords(
				item.el.closest('.component-sticky')
			).top;
			const stopTargets = item.el
				.closest('.component-sticky')
				.dataset.stop.split(',')
				.map((element) => {
					return element.trim();
				});
			const stopPositions = [];
			stopTargets.forEach((el) => {
				document.querySelectorAll(el).forEach((el2) => {
					stopPositions.push(this.getCoords(el2).top);
				});
			});
			let logicalStop = 0;
			stopPositions.sort(function (a, b) {
				return a - b;
			});
			stopPositions.forEach((el) => {
				if (
					0 === logicalStop &&
					el > this.stickyComponentAttributes[i].stickTop
				) {
					logicalStop = el;
				}
			});
			this.stickyComponentAttributes[i].stickBottom = logicalStop;
			this.stickyComponentAttributes[i].targetPositions = [];
			if (item.anchorLinks) {
				Array.prototype.forEach.call(item.anchorLinks, (link) => {
					const target = document.querySelector(
						link.getAttribute('href')
					);
					if ( !!target ) {
						this.stickyComponentAttributes[i].targetPositions.push(
							this.getCoords(target).top -
								this.stickyComponentAttributes[i].navHeight
						);
					}
				});
			}
			// first item to remain active past upward scroll lock
			if (
				0 === i &&
				this.stickyComponentAttributes[i].targetPositions[0]
			) {
				this.stickyComponentAttributes[i].targetPositions[0] = 0;
			}
		});
	}
	changeNavClasses() {
		// change position based on scroll

		this.stickyComponentAttributes.forEach((item) => {
			if (
				window.scrollY >= item.stickTop &&
				window.scrollY + item.navHeight <= item.stickBottom
			) {
				item.el.classList.remove('component-sticky__sticky--relative');
				item.el.classList.remove('component-sticky__sticky--absolute');
				item.el.classList.add('component-sticky__sticky--fixed');
				item.el.style.top = 0;
			} else {
				item.el.classList.remove('component-sticky__sticky--fixed');
				if (window.scrollY < item.stickTop) {
					item.el.classList.add('component-sticky__sticky--relative');
					item.el.style.top = 'auto';
				} else {
					item.el.classList.add('component-sticky__sticky--absolute');
					item.el.style.top =
						item.stickBottom -
						this.getCoords(item.el.offsetParent).top -
						item.navHeight +
						'px';
				}
			}
		});
	}
	changeNavActive() {
		this.stickyComponentAttributes.forEach((item, i) => {
			if (
				this.stickyComponentAttributes[i].el.classList.contains(
					'component-sticky__sticky--fixed'
				) &&
				this.stickyComponentAttributes[i].linkActiveClass &&
				this.stickyComponentAttributes[i].anchorLinks
			) {
				let activeIndex = 0;
				this.stickyComponentAttributes[i].targetPositions.forEach(
					(position, index) => {
						this.stickyComponentAttributes[i].anchorLinks[
							index
						].classList.remove(
							this.stickyComponentAttributes[i].linkActiveClass
						);
						if ((window.scrollY + 86) >= position) {
							activeIndex = index;
						}
					}
				);
				this.stickyComponentAttributes[i].anchorLinks[
					activeIndex
				].classList.add(
					this.stickyComponentAttributes[i].linkActiveClass
				);
				this.stickyComponentAttributes[i].el.querySelector(
					'.component-sticky__button'
				).textContent =
					this.stickyComponentAttributes[i].anchorLinks[
						activeIndex
					].textContent;
			}
		});
	}
	getCoords(elem) {
		if (elem) {
			const box = elem.getBoundingClientRect();

			const body = document.body;
			const docEl = document.documentElement;

			const scrollTop =
				window.pageYOffset || docEl.scrollTop || body.scrollTop;
			const scrollLeft =
				window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

			const clientTop = docEl.clientTop || body.clientTop || 0;
			const clientLeft = docEl.clientLeft || body.clientLeft || 0;

			const top = box.top + scrollTop - clientTop;
			const left = box.left + scrollLeft - clientLeft;

			return { top: Math.round(top), left: Math.round(left) };
		}
	}
}

const newSticky = new Sticky();

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		newSticky.getTargetPositions();
		newSticky.changeNavClasses();
		newSticky.changeNavActive();
	},
	loaded() {
		newSticky.getTargetPositions();
		newSticky.changeNavClasses();
		newSticky.changeNavActive();
	},
	resized() {
		newSticky.getTargetPositions();
		newSticky.changeNavClasses();
		newSticky.changeNavActive();
	},
	scrolled() {
		newSticky.changeNavClasses();
		newSticky.changeNavActive();
	},
	keyDown() {},
	mouseUp() {},
	pageHeightChange() {
		newSticky.getTargetPositions();
		newSticky.changeNavClasses();
		newSticky.changeNavActive();
	},
};
export default controller;
